<template>
	<div class="page-users page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">参数管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>系统管理</el-breadcrumb-item>
							<el-breadcrumb-item>参数管理</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="dataKey" label="key名：" style="margin-bottom: 0;">
							<el-input v-model="form_search.dataKey" size="small" placeholder="dataKey" clearable></el-input>
						</el-form-item>
						<el-form-item prop="dataText" label="值：">
							<el-input v-model="form_search.dataText"  size="small" placeholder="dataText"
								clearable></el-input>
						</el-form-item>
						
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
					
					
				</div>
				<div class="table-block content-body">
					<div class="" style="display: flex;flex-direction: row;justify-content: flex-end;">
						<el-button type="primary" class="search-btn" size="medium" @click="handleUser('add')">添加参数
						</el-button>
					</div>
					<div ref="contentBody">
						
						
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							
							<el-table-column prop="dataKey" align="center" label="dataKey" min-width="160">
							</el-table-column>
							
							<el-table-column prop="dataText"  align="center" label="dataText" min-width="100">
							</el-table-column>
							<el-table-column prop="dataValue"  align="center" label="dataValue" min-width="160">
								
							</el-table-column>
							<el-table-column prop="createdate" align="center" label="创建时间" min-width="120">
							</el-table-column>
							
							
							<el-table-column prop="operating" align="center" label="操作" min-width="180" fixed="right">
								<template slot-scope="scope">
									
									<el-button class="option-btn btn-bd-s" type="primary" size="mini"
										@click="handleUser('edit',scope.row)">编辑</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteParamsimple(scope.row.icode)">删除参数</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
			<!-- 用户编辑弹窗-->
			<el-dialog class="dialog-export card-dialog" :title="dlg_card.title" :visible.sync="dlg_card.visible"
				width="534px" @closed="closeCard" :close-on-click-modal="false">
				<el-form ref="formCard" :model="dlg_card.form" label-width="110px" :rules="dlg_card.rules"
					@submit.native.prevent>
					<el-form-item prop="dataText" label="dataText：">
						<el-input size="small" v-model="dlg_card.form.dataText" placeholder='dataText' clearable>
						</el-input>
					</el-form-item>
					<el-form-item prop="dataValue" label="dataValue：" >
						<el-input size="small" v-model="dlg_card.form.dataValue" placeholder='请输入dataValue' clearable>
						</el-input>
					</el-form-item>
					<el-form-item prop="dataKey" label="dataKey：">
						<el-input size="small"  v-model="dlg_card.form.dataKey" placeholder='请输入dataKey' clearable>
						</el-input>
					</el-form-item>
					
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dlg_card.visible = false">取 消</el-button>
					<el-button type="primary" @click="submitUser()" :loading="dlg_card.btn_loading">确认</el-button>
				</span>
			</el-dialog>
			
			
			<!-- 图片放大 -->
			<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
				<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
			</el-dialog>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				form_search: {

					dataKey: '',
					dataText:'',
				},
				init_data: {
					status_list: [
						{id:0, name: '禁用'},{id:1, name: '启用'}
					],
					type_list: [],
					sex_list:[{id:0, name: '女'},{id:1, name: '男'},]
				},
				is_master_show: false,
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				
				
				dlg_card: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					form: {
						
						icode:'',
						dataValue:'',
						dataKey: '',
						dataText:'',
						
					},
					error: {
						loginId: '',
				
					},
					reset_form: {},
					init_data: {
						status_list: [],
						 show_name_list:[{id:1, name: '开启'},{id:0, name: '关闭'}]
					},
					rules: {
							dataValue: {required: true,message: 'dataValue不能为空'},
							dataKey:{required: true,message: 'dataKey不能为空'},
							dataText:{required: true,message: 'dataText不能为空'},
							
					},
					params: {
						headers: {
							token: localStorage.getItem('token')
						}
					}
				},
				
				dlg_preview: {
					visible: false,
					img_url: ''
				},
				dlg_role:{
					data:[],
					defaultProps: {
					    children: 'children',
					    label: 'name',
						// roleKey:'roleKey'
					},
					default_list:[]
				},
			}
		},
		created() {
			document.title = '参数列表';
			this.getList();
		},
		methods: {
			
			//查询
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			
			
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.pageNo = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				
				
				this.$client.get('/api/sys/paramsimple/getList', params, function(res, message,total,totalPages) {
					_this.table_data.list = res;
					//_this.table_data.page_info.page = totalPages;
					_this.table_data.page_info.total = total;
					
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleUser(type, data) {
				this.dlg_card.visible = true;
				this.dlg_role.default_list=[]
				if (type == 'add') {
					this.dlg_card.title = '添加参数';
					this.dlg_card.api = '/api/sys/paramsimple/save';
				} else {
					this.dlg_card.id = data.id;
					this.dlg_card.title = '编辑参数';
					if (data) {
						for (var key in this.dlg_card.form) {
							this.dlg_card.form[key] = data[key];
						}
					}
					this.dlg_card.api = '/api/sys/paramsimple/save';
				}
			},
			handleSizeChange(val) {
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.table_data.page_info.page = val;
				this.getList();
			},
			
			submitUser() {
				 
				var _this = this;

				_this.$refs['formCard'].validate((valid) => {
					if (valid) {
						this.dlg_card.btn_loading = true;
						this.$client.post(this.dlg_card.api, this.dlg_card.form, function(res, message) {
							_this.$message(message);
							_this.getList();
							_this.dlg_card.btn_loading = false;
							_this.dlg_card.visible = false;
						}, function(message) {
							_this.dlg_card.btn_loading = false;
							if ((typeof message) === 'object') {
								for (var key in message) {
									_this.dlg_card.error[key] = message[key];
								}
							}
						});
					} else {
						return false;
					}
				});
			},
			//删除用户
			 deleteParamsimple(id){
				var _this = this;
				this.$confirm('确定要删除？', "", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							iconClass:"icon-delete el-icon-delete",
							customClass:"my-confirm-box",
							center: true,
						})
						.then(() => {
					_this.$client.post('/api/sys/paramsimple/delete', {id:id}, function(res,message){
					_this.getList();
					
				},function(res){

				});
			})
			.catch(() => {});
			},
			closeCard() {
				this.dlg_card.img_list = [];
				this.dlg_card.hide_upload = false;
				for (var key in this.dlg_card.form) {
					this.dlg_card.form[key] = this.dlg_card.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formCard.clearValidate();
				})
			},
			
		
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.balance-title {
		text-align: center;
		font-size: 18px;
		color: #161616;
	}

	.balance-text {
		font-size: 14px;
		color: #161616;
		padding: 20px;
		text-align: center;
		margin-bottom: 20px;
	}

	.balance-text span {
		font-size: 24px;
	}
</style>
